export default "__VITE_ASSET__d27df56f__"